/**
 * @file 本地开发登录入口
 */
import React, { useState } from 'react'

const DevelopmentLoginModal = React.lazy(() => import('./LoginModal'))

export default ({ signIn }) => {
  const [loginVisible, setLoginVisible] = useState(false)

  return (
    <>
      <a style={{ fontSize: 14 }} onClick={() => setLoginVisible(true)}>
        模拟登录
      </a>
      {loginVisible && (
        <React.Suspense fallback={<div>正在加载中</div>}>
          <DevelopmentLoginModal
            visible={loginVisible}
            signIn={signIn}
            close={() => setLoginVisible(false)}
          />
        </React.Suspense>
      )}
    </>
  )
}
